document.addEventListener('readystatechange', function() {
  const wpGoogleReviews = document.querySelector('.wp-gr');
  if( !wpGoogleReviews )
    return;

  // Get place link
  const placeLink = wpGoogleReviews.querySelector('a');
  /** @type {HTMLElement} */
  const reviewsEl = wpGoogleReviews.querySelector('.wp-google-powered');

  // Apply link to content
  reviewsEl.setAttribute('role', 'link');
  reviewsEl.tabIndex = '0';
  reviewsEl.addEventListener('click', function() {
    window.open(placeLink.href, '_blank');
  }, false);

});
